export default "data:image/webp;base64,"